import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-fan",
  "use": "dv-fan-usage",
  "viewBox": "0 0 107 107",
  "content": "<symbol viewBox=\"0 0 107 107\" id=\"dv-fan\"><title>资源 115</title><g id=\"dv-fan_图层_2\" data-name=\"图层 2\"><g id=\"dv-fan_图层_1-2\" data-name=\"图层 1\"><path d=\"M62.91,51.08a10.7,10.7,0,0,0-1-2.33c5.62-16.25,38.11,1.8,42.35-10.66C110,12.16,86.46,0,76.75,0,51,1.35,50.55,33.49,51.09,44.11a10,10,0,0,0-2.34.95C32.51,39.43,50.57,6.93,38.1,2.7,12.17-3,0,20.53,0,30.26,1.35,56,33.48,56.45,44.12,55.92a9.48,9.48,0,0,0,.94,2.33C39.44,74.49,6.95,56.44,2.69,68.91-3,94.84,20.53,107,30.27,107,56,105.65,56.45,73.52,55.92,62.89a9,9,0,0,0,2.32-.95c16.26,5.62-1.8,38.12,10.66,42.35C94.84,110,107,86.47,107,76.73,105.65,51,73.53,50.55,62.91,51.08ZM53.5,60.45a6.94,6.94,0,1,1,6.93-7A6.95,6.95,0,0,1,53.5,60.45Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-fan.svg
// module id = gd0Y
// module chunks = 264